import { RestaurantModifierGroupDTO } from '../../../types/restaurant/RestaurantCatalogExtensionTypes';
import { RestaurantMenuItemDTO } from '../../../types/restaurant/RestaurantMenuTypes';
import { normalizeMenuConfigurationModifierGroups } from '../menu/configuration/menuConfigurationUtils';

export const activeModifierGroupsForMenuItem = (
  value: unknown,
  item: RestaurantMenuItemDTO
): RestaurantModifierGroupDTO[] =>
  normalizeMenuConfigurationModifierGroups(value)
    .filter(
      (group) =>
        group.active && (!group.branchId || group.branchId === item.branchId)
    )
    .map((group) => ({
      ...group,
      modifiers: group.modifiers.filter(
        (modifier) => modifier.active && modifier.groupId === group.id
      ),
    }));

export const validRestaurantModifierSelection = (
  groups: RestaurantModifierGroupDTO[],
  selectedIds: number[]
) =>
  groups.every((group) => {
    const count = group.modifiers.filter(
      (modifier) => modifier.active && selectedIds.includes(modifier.id)
    ).length;
    const minimum = group.required
      ? Math.max(1, group.minSelections)
      : group.minSelections;

    return count >= minimum && count <= group.maxSelections;
  });

export const restaurantItemPriceWithModifiers = (
  itemPrice: number,
  groups: RestaurantModifierGroupDTO[],
  selectedIds: number[]
) =>
  Number(itemPrice) +
  groups
    .flatMap((group) => group.modifiers)
    .filter((modifier) => selectedIds.includes(modifier.id))
    .reduce((total, modifier) => total + Number(modifier.priceAdjustment), 0);
